"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var ImportStar_1 = __importDefault(require("../../../icons/ImportStar"));
var Typography_1 = __importDefault(require("../../Typography"));
var DragAndDropBox_1 = __importDefault(require("../../DragAndDropBox/DragAndDropBox"));
var Icon_1 = __importDefault(require("../../Icon"));
var styles_1 = require("../../Modal/styles");
var styles_2 = require("./styles");
var MainDialog = function (_a) {
    var onFiles = _a.onFiles, title = _a.title, supportText = _a.supportText, subActionText = _a.subActionText, clickText = _a.clickText, dragAndDropText = _a.dragAndDropText, inputAccept = _a.inputAccept, isMultiple = _a.isMultiple, onClose = _a.onClose;
    return ((0, jsx_runtime_1.jsxs)(styles_2.Container, { children: [(0, jsx_runtime_1.jsxs)(styles_2.Header, { children: [(0, jsx_runtime_1.jsx)(ImportStar_1.default, {}), (0, jsx_runtime_1.jsx)(styles_1.CloseContainer, __assign({ onClick: onClose, "data-testid": "import-file-close-button" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "close", size: "xl" }) }))] }), (0, jsx_runtime_1.jsx)(Typography_1.default.H6, { children: title }), (0, jsx_runtime_1.jsx)(styles_2.SupportText, { children: supportText }), (0, jsx_runtime_1.jsx)(DragAndDropBox_1.default, { onFiles: onFiles, supportedTypesText: subActionText, clickText: clickText, dragAndDropText: dragAndDropText, inputAccept: inputAccept, isMultiple: isMultiple })] }));
};
exports.default = MainDialog;
